module.exports = global["Globalize"] = require("-!/home/travis/build/coveo/search-ui/lib/globalize/globalize.min.js");


/*****************
 ** WEBPACK FOOTER
 ** ./lib/globalize/globalize.min.js
 ** module id = 30
 ** module chunks = 0 1
 **/